import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { Trash2, Pencil, CircleCheck, TriangleAlert, Info } from 'lucide-react';
import hexToRgbChannels from '../../assets/js/hexToRgbChannels';
import '../../assets/styles/AppModal.css';

export const MODAL_VARIANTS = {
  delete: { icon: Trash2, tone: '#BA1A1A' },
  edit: { icon: Pencil, tone: '#7C3AED' },
  confirm: { icon: CircleCheck, tone: '#0D9488' },
  warning: { icon: TriangleAlert, tone: '#D97706' },
  info: { icon: Info, tone: '#2563EB' }
};

const Modal = ({
  open,
  onOpenChange,
  variant,
  icon,
  tone,
  title,
  description,
  children,
  cancelText,
  confirmText,
  onConfirm,
  onCancel,
  confirmDisabled = false,
  size = 'sm',
  className = ''
}) => {
  const preset = variant ? MODAL_VARIANTS[variant] : null;
  const PresetIcon = preset ? preset.icon : null;
  const shownIcon = icon || (PresetIcon ? <PresetIcon size={18} strokeWidth={2} /> : null);
  const color = tone || (preset ? preset.tone : null);
  const rgb = color ? hexToRgbChannels(color) : null;

  const handleConfirm = (event) => {
    if (!onConfirm) return;
    const result = onConfirm(event);
    if (result === false) event.preventDefault();
  };

  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="tp-modal__overlay" />
        <AlertDialog.Content
          className={['tp-modal', `tp-modal--${size}`, shownIcon ? 'has-icon' : '', className].filter(Boolean).join(' ')}
          style={rgb ? { '--modal-rgb': rgb } : undefined}
          {...(description ? {} : { 'aria-describedby': undefined })}
        >
          <div className="tp-modal__top">
            {shownIcon && (
              <span className="tp-modal__icon" aria-hidden="true">{shownIcon}</span>
            )}
            <div className="tp-modal__header">
              <AlertDialog.Title className="tp-modal__title">{title}</AlertDialog.Title>
              {description && (
                <AlertDialog.Description className="tp-modal__description">
                  {description}
                </AlertDialog.Description>
              )}
            </div>
          </div>

          {children && <div className="tp-modal__body">{children}</div>}

          <div className="tp-modal__footer">
            {cancelText && (
              <AlertDialog.Cancel className="btn tp-modal__cancel" onClick={onCancel}>
                {cancelText}
              </AlertDialog.Cancel>
            )}
            {confirmText && (
              <AlertDialog.Action
                className="btn tp-modal__confirm"
                onClick={handleConfirm}
                disabled={confirmDisabled}
              >
                {confirmText}
              </AlertDialog.Action>
            )}
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};

export default Modal;
export { Modal };
